import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formatVP } from '../../../../helpers/helperFunctions';
import { CaptionText } from '../../../../styles/FontStyles';
import { color } from '../../../../styles/GlobalStyles';

export const RootTeamMemberInfo = ({ tab }) => {
  const { t } = useTranslation('myTeam');

  const { rootTeamMemberInfo, userAsTeamMemberInfo } = useSelector(
    (store) => store.myTeamBackoffice
  );

  return (
    <>
      <CaptionText center color={color.colors.neutral700} mbSM='6'>
        {t('country')}:{' '}
        <CaptionText bold inline color={color.colors.neutral700}>
          {tab === 'volume' || tab === 'generations'
            ? userAsTeamMemberInfo?.country
            : rootTeamMemberInfo?.country ?? '---'}
        </CaptionText>
      </CaptionText>

      <CaptionText center color={color.colors.neutral700} mbSM='6'>
        {t('rank')}:{' '}
        <CaptionText bold inline color={color.colors.neutral700}>
          {tab === 'volume' || tab === 'generations'
            ? userAsTeamMemberInfo?.userPackage?.packageRank?.name
            : rootTeamMemberInfo?.userPackage?.packageRank?.name ?? '---'}
        </CaptionText>
      </CaptionText>

      <CaptionText center color={color.colors.neutral700} mbSM='6'>
        {t('sponsor')}:{' '}
        <CaptionText bold inline color={color.colors.neutral700}>
          {rootTeamMemberInfo?.referrerUser ? (
            <>
              {`${rootTeamMemberInfo?.referrerUser?.username || '---'}`} (#
              {rootTeamMemberInfo?.referrerUser?.id})
            </>
          ) : (
            '---'
          )}
        </CaptionText>
      </CaptionText>
      <CaptionText
        center
        color={color.colors.neutral700}
        mbSM='5'
        mobile={true}>
        {t('direct_volume')}:{' '}
        <CaptionText bold inline color={color.colors.neutral700}>
          {formatVP(rootTeamMemberInfo?.directTotalVolume)}
        </CaptionText>
      </CaptionText>
    </>
  );
};
